import { redirect, useLoaderData } from "react-router-dom";

import { pget } from "@/api";
import { Models } from "@/api/types";
import { GiftCardsPurchaseContainer } from "@/modules/giftCards";
import { getGiftCardInfo } from "@/modules/giftCards/giftCards.utils";
import { waitObj } from "@/toolbox/Promise";

import { queryClient } from "../../Root";

const getPlatform = pget("/platform/current");
const getGiftCards = pget("/gift-cards/public/{platformId}/listings");
const getGiftCardItemsDiscounts = pget(
  "/gift-cards/public/{platformId}/discounts"
);

async function loader({ request }: { request: Request }) {
  let platform;
  try {
    platform = await queryClient.fetchQuery(getPlatform.key(), () =>
      getPlatform()
    );
  } catch (error) {
    console.error("Error fetching platform data:", error);
    throw redirect("/");
  }

  if (!platform.platformSettings?.giftCardEnabled) {
    throw redirect("/");
  }

  const giftCards = await queryClient.fetchQuery(
    getGiftCards.key({ platformId: platform.id }),
    () => getGiftCards({ platformId: platform.id })
  );

  const giftCardItemsDiscounts = await queryClient.fetchQuery(
    getGiftCardItemsDiscounts.key({ platformId: platform.id }),
    () => getGiftCardItemsDiscounts({ platformId: platform.id })
  );

  const {
    giftCardListingId,
    giftCardItemId,
    sharingPersonFirstName,
    sharingPersonLastName,
    sharingPersonPhone,
    sharingPersonEmail,
    intendedBuyerUser,
  } = await getGiftCardInfo(request);

  return waitObj({
    platform,
    giftCards,
    giftCardListingId,
    giftCardItemId,
    sharingPersonFirstName,
    sharingPersonLastName,
    sharingPersonPhone,
    sharingPersonEmail,
    intendedBuyerUser,
    giftCardItemsDiscounts,
  });
}

export const purchaseGiftCardLoader = loader;

const GiftCardPurchasePage = () => {
  const {
    giftCards,
    platform,
    giftCardListingId,
    giftCardItemId,
    sharingPersonFirstName,
    sharingPersonLastName,
    sharingPersonPhone,
    sharingPersonEmail,
    intendedBuyerUser,
    giftCardItemsDiscounts,
  } = useLoaderData() as {
    giftCards: Models<"DisplayGiftCardListing">[];
    platform: Models<"PlatformModel">;
    giftCardListingId: string | null;
    giftCardItemId: string | null;
    sharingPersonFirstName: string | null;
    sharingPersonLastName: string | null;
    sharingPersonPhone: string | null;
    sharingPersonEmail: string | null;
    intendedBuyerUser: Models<"UserModel1"> | null;
    giftCardItemsDiscounts: Models<"DisplayGiftCardItemsDiscounts">[];
  };

  return (
    <div className="GiftCardPurchasePage flex flex-col">
      <GiftCardsPurchaseContainer
        giftCards={giftCards}
        platform={platform}
        giftCardListingId={giftCardListingId}
        giftCardItemId={giftCardItemId}
        sharingPersonFirstName={sharingPersonFirstName}
        sharingPersonLastName={sharingPersonLastName}
        sharingPersonPhone={sharingPersonPhone}
        sharingPersonEmail={sharingPersonEmail}
        intendedBuyerUser={intendedBuyerUser}
        giftCardItemsDiscounts={giftCardItemsDiscounts}
      />
    </div>
  );
};

export default GiftCardPurchasePage;
